import { render } from "./CollapsePanel.vue?vue&type=template&id=ef58d3e4"
import script from "./CollapsePanel.vue?vue&type=script&lang=js"
export * from "./CollapsePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__